var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attribute-pill mr-1 mb-1",style:({ backgroundColor: _vm.item.color })},[_vm._v(" "+_vm._s(_vm.item.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }